import { createSlice } from "@reduxjs/toolkit";
import { normalizeAppSettings } from "./core/fetchAppSettings";
const initialState = {
    isPartner: false,
    appSettings: null,
    lastAppSettingUpdatedAt: null,
    deviceType: null,
    applicationId: null,
};
export const appSlice = createSlice({
    name: "app",
    initialState,
    reducers: {
        setAppSettings: (state, action) => {
            state.appSettings = normalizeAppSettings(action.payload);
            state.lastAppSettingUpdatedAt = new Date().getTime();
        },
        setDeviceType: (state, action) => {
            state.deviceType = action.payload;
        },
        setApplicationId: (state, action) => {
            state.applicationId = action.payload;
        },
        setIsPartner: (state, action) => {
            state.isPartner = action.payload;
        },
    },
});
export const { setAppSettings, setDeviceType, setApplicationId, setIsPartner } = appSlice.actions;
export default appSlice.reducer;
